import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findPointsDetails = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_details?`+params,
        method: 'GET'
    })
}

export const approve = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_details/approve`,
        method: 'PUT',
        data: data
    })
}
